module.exports = __webpack_public_path__ + "static/armPageBg-a86bde508eea5215275fe648c78c5867.jpg";